/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.IPage<defs.tms.CabinMasterResponseDto>>;
export function request(
  params: API.tms.cabinMasterSelfWhole.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMasterSelfWhole/page`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
